<template>
  <div>
    <a-card class="l-container mt-4 mb-4">
      <a-button @click="visible = true"  preset="card"> Start Me up </a-button>
    </a-card>

    <Modal :visible="visible" size="large" @ok="visible = false" @cancel="visible = false">
      <a-card :bordered="false">
        <div class="content-modal" :class="{collapse: selected}">
          <div class="modal-container">
            <div class="title">
              <p>こだわり条件を指定</p>
            </div>
            <div class="select-price">
              <div class="title">
                <h1>合計料金</h1>
                <p>（1泊)</p>
              </div>
              <div class="select">
                <a-select class="select-item" placeholder="下限なし">
                  <a-select-option :value="op.value" v-for="(op, index) in optionsFrom" :key="`${index}`">
                    {{op.label}}
                  </a-select-option>
                </a-select>
                <span class="self-center">〜</span>
                <a-select class="select-item" placeholder="上限なし">
                  <a-select-option :value="op.value" v-for="(op, index) in optionsTo" :key="`${index}`">
                    {{op.label}}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div class="select-evaluate">
              <div class="title">
                <h1>クチコミ</h1>
              </div>
              <div class="select">
                <a-select  placeholder="すべて" class="select-item">
                  <a-select-option :value="op.value" v-for="(op, index) in optionsEvaluate" :key="`${index}`">
                    {{op.label}}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <a-divider />
            <div v-for="(item, index) in dataCheckbox" :key="index">
              <div class="room-type">
                <h1>{{ item.title }}</h1>
                <div class="checkbox-group">
                  <a-checkbox-group :value="rooms">
                    <a-row :y-gap="8" :cols="2">
                      <a-col
                        v-for="(item, index) in item.listCheckbox"
                        :key="index"
                      >
                        <a-checkbox :value="item.value" >{{item.label}}</a-checkbox>
                      </a-col>
                    </a-row>
                  </a-checkbox-group>
                </div>
              </div>
              <a-divider v-if="index < dataCheckbox.length - 1" />
            </div>
          </div>
        </div>
        <div class="button">
          <Button @click="selected = !selected"
                  class="button-item">絞り込む（000件）</Button>
        </div>
      </a-card>
    </Modal>
  </div>
</template>

<script>
import { Button, Modal } from '@/components/primitive'

export default {
  components: {
    Button,
    Modal
  },
  data() {
    return {
      rooms: null,
      selected: false,
      visible: false,
      priceValue: null,
      evaluateValue: null,

      optionsFrom: [
        {
          label: '下限なし',
          value: '下限なし'
        },
        {
          label: '下限なし',
          value: '下限なし'
        }
      ],
      optionsTo: [
        {
          label: '上限なし',
          value: '上限なし'
        },
        {
          label: '上限なし',
          value: '上限なし'
        }
      ],
      optionsEvaluate: [
        {
          label: 'すべて',
          value: 'すべて'
        },
        {
          label: 'すべて',
          value: 'すべて'
        }
      ],
      status: true,
      dataCheckbox: [
        {
          title: '部屋タイプ',
          listCheckbox: [
            {
              value: 'シングル　(0000)',
              label: 'シングル　(0000)'
            },
            {
              value: 'ツイン　(0000)',
              label: 'ツイン　(0000)'
            },
            {
              value: 'セミダブル　(0000)',
              label: 'セミダブル　(0000)'
            },
            {
              value: 'トリプル以上　(0000)',
              label: 'トリプル以上　(0000)'
            },
            {
              value: '和室　(0000)',
              label: '和室　(0000)'
            },
            {
              value: '和洋室　(0000)',
              label: '和洋室　(0000)'
            }
          ]
        },
        {
          title: '食事条件',
          listCheckbox: [
            {value: '食事なし　(0000)', label: '食事なし　(0000)'},
            {value: '夕食のみ　(0000)', label: '夕食のみ　(0000)'},
            { value: '朝食のみ　(0000)', label: '朝食のみ　(0000)' },
            {value: '朝食・夕食あり　(0000)', label: '朝食・夕食あり　(0000)'}
          ]
        },
        {
          title: '部屋のこだわり',
          listCheckbox: [
            { value: '禁煙　(0000)', label: '禁煙　(0000)' },
            { value: '喫煙　(0000)', label: '喫煙　(0000)'},
            { value: '露天風呂付　(0000)', label: '露天風呂付　(0000)'},
            { value: 'インターネット可　(0000)', label: 'インターネット可　(0000)'},
            { value: '高層階　(0000)', label: '高層階　(0000)'},
            { value: 'オーシャンビュー　(0000)', label: 'オーシャンビュー　(0000)'},
            { value: '山が見える　(0000)', label: '山が見える　(0000)'},
            { value: '湖が見える　(0000)', label: '湖が見える　(0000)'},
            { value: '川が見える　(0000)', label: '川が見える　(0000)'},
            { value: '夜景が見える　(0000)', label: '夜景が見える　(0000)'},
            { value: 'ベビーベッドあり　(0000)', label: 'ベビーベッドあり　(0000)'},
            { value: 'ペットOK　(0000)', label: 'ペットOK　(0000)'},
            { value: 'バリアフリー対応　(0000)', label: 'バリアフリー対応　(0000)'},
            { value: '部屋で夕食　(0000)', label: '部屋で夕食　(0000)'}
          ]
        },
        {
          title: '利用方法',
          listCheckbox: [
            { value: '給与天引きで支払可　(0000)', label: '給与天引きで支払可　(0000)' },
            { value: 'ベネポが使えるプラン　(0000)', label: 'ベネポが使えるプラン　(0000)'},
            { value: '会員証・クーポン呈示利用可　(0000)', label: '会員証・クーポン呈示利用可　(0000)'},
            { value: 'ベネポが貯まるプラン　(0000)', label: 'ベネポが貯まるプラン　(0000)'},
            { value: 'オンラインカード決済が使える　(0000)', label: 'オンラインカード決済が使える　(0000)'}
          ]
        },
        {
          title: '特典',
          listCheckbox: [
            { value: '25％OFF以上の特典を含む　(0000)', label: '25％OFF以上の特典を含む　(0000)'},
            { value: '70％以上の特典を含む　(0000)', label: '70％以上の特典を含む　(0000)'},
            { value: '50％以上の特典を含む　(0000)', label: '50％以上の特典を含む　(0000)'},
            { value: '無料　(0000)', label: '無料　(0000)'}
          ]
        },
        {
          title: '提供会社',
          listCheckbox: [
            { value: 'Beneオリジナル　(0000)', label: 'Beneオリジナル　(0000)'},
            { value: 'Bene楽天トラベル　(0000)', label: 'Bene楽天トラベル　(0000)'}
          ]
        }
       
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
